"use client"

import { useEffect, useState } from "react"

const DEFAULT_DELAY_MS = 300

/**
 * Holds a busy flag back until it has been true for `delayMs`, so a response that
 * arrives quickly never paints a loading state at all. Filters and sort fire
 * constantly and most land inside the delay; without it every one of them flashes
 * the grid to 40% and back, which reads as a glitch rather than as progress.
 *
 * Falls to false immediately — once the work is done there is nothing to announce.
 */
export const useDelayedFlag = (active: boolean, delayMs: number = DEFAULT_DELAY_MS): boolean => {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    if (!active) {
      setShown(false)
      return
    }
    const id = setTimeout(() => setShown(true), delayMs)
    return () => clearTimeout(id)
  }, [active, delayMs])

  return shown
}
